<mat-dialog-title class="mb1 p0" fxLayout="row" fxLayoutAlign="space-between center">
	<p class="h2" [style.margin]="'0'">{{ 'dialogs.overwriteBackendEndpoint.title' | translate }}</p>
	<button mat-icon-button mat-dialog-close [attr.aria-label]="'common.close' | translate">
		<mat-icon>close</mat-icon>
	</button>
</mat-dialog-title>
<mat-dialog-content class="mat-typography">
	<table
		mat-table
		[dataSource]="endpoints"
		class="mat-elevation-z2"
		[attr.aria-label]="'dialogs.overwriteBackendEndpoint.tableLabel' | translate"
	>
		<ng-container matColumnDef="serviceName">
			<th mat-header-cell *matHeaderCellDef scope="Service Name">{{ 'dialogs.overwriteBackendEndpoint.serviceName' | translate }}</th>
			<td mat-cell *matCellDef="let endpoint">{{ endpoint.serviceName }}</td>
		</ng-container>
		<ng-container matColumnDef="endpointValue">
			<th mat-header-cell *matHeaderCellDef scope="Endpoint Value">{{ 'dialogs.overwriteBackendEndpoint.endpoint' | translate }}</th>
			<td mat-cell *matCellDef="let endpoint">{{ endpoint.endpoint }}</td>
		</ng-container>
		<ng-container matColumnDef="edit">
			<th mat-header-cell *matHeaderCellDef scope="Edit button">{{ 'common.edit' | translate }}</th>
			<td mat-cell *matCellDef="let endpoint" [style.cursor]="'default'">
				<button
					mat-icon-button
					(click)="editBackendEndpoint(endpoint.serviceName, endpoint.endpoint)"
					[attr.aria-label]="'dialogs.overwriteBackendEndpoint.editEndpoint' | translate"
				>
					<mat-icon>edit</mat-icon>
				</button>
			</td>
		</ng-container>
		<ng-container matColumnDef="reset">
			<th mat-header-cell *matHeaderCellDef scope="Reset button">{{ 'common.reset' | translate }}</th>
			<td mat-cell *matCellDef="let endpoint" [style.cursor]="'default'">
				<button
					mat-icon-button
					(click)="resetBackendEndpoint(endpoint.serviceName)"
					[disabled]="endpoint.endpoint === environmentEndpoints[endpoint.serviceName]"
					[attr.aria-label]="'dialogs.overwriteBackendEndpoint.resetEndpoint' | translate"
				>
					<mat-icon>restore</mat-icon>
				</button>
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row matRipple *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</mat-dialog-content>
